import {
  buildPublicUserInteractionData,
  createPublicUserInteraction,
  postPublicUserInteractionMessage,
} from "InRangeAPI";
import { Trans, useTranslation } from "react-i18next";
import Button from "./Button";

const ClaimBuilding = ({
  claimed,
  setClaimed,
  values,
  formValues,
  buildingKey,
  buildingPoint,
  buildingPostcodeAddress,
}) => {
  const { t } = useTranslation("analyse");

  const handleClick = () => {
    const data = buildPublicUserInteractionData(
      formValues,
      buildingKey,
      buildingPoint,
      buildingPostcodeAddress,
      values
    );
    const companyEmail = formValues.companyEmail;
    const name = formValues.firstName + " " + formValues.lastName;
    const latitude = buildingPoint[0];
    const longitude = buildingPoint[1];
    const status = "VALID_BUILDING";

    setClaimed(true);
    postPublicUserInteractionMessage(data, "CLAIM_BUILDING");
    createPublicUserInteraction(
      companyEmail,
      latitude,
      longitude,
      name,
      buildingKey,
      status
    );
  };

  return (
    <div>
      <p className="my-3">
        <Trans i18nKey="analyse:claim.prompt" components={{ 1: <b /> }} />
      </p>
      <Button disabled={claimed} onClick={handleClick} className="mb-5">
        {claimed ? t("claim.claimed") : t("claim.cta")}
      </Button>
      {claimed ? (
        <div>
          <Trans
            i18nKey="analyse:claim.followup"
            components={{
              1: (
                <a
                  className="underline"
                  href="https://blog.inrange.io/"
                  target="_blank"
                  rel="noreferrer"
                >
                  .
                </a>
              ),
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ClaimBuilding;
